import { Fragment } from 'react';
import PreviewBackground from 'ContentComponents/components/cmv2/media/PreviewBackground';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
const VideoPreviewContainer = props => /*#__PURE__*/_jsx(Fragment, {
  children: /*#__PURE__*/_jsx(PreviewBackground, {
    children: /*#__PURE__*/_jsx(TFlex, {
      justify: "center",
      children: /*#__PURE__*/_jsx(Box, {
        basis: 400,
        children: props.children
      })
    })
  })
});
export default VideoPreviewContainer;